import React, { SVGProps } from 'react';

// Re-export all icons
export * from './CanvaDoc';
export * from './CanvaPresentation';
export * from './CanvaWhiteboard';
export * from './accept-connection';
export * from './AddEvent';
export * from './arrow-down-tray';
export * from './ArrowRight';
export * from './bell-on';
export * from './BellOff';
export * from './Bold';
export * from './BubbleWarning';
export * from './calendar';
export * from './camera';
export * from './cash';
export * from './check';
export * from './check-circle';
export * from './check-fill';
export * from './clock';
export * from './checked';
export * from './CheckCircleFilled';
export * from './CheckCircleIndeterminate';
export * from './CheckCircleOutline';
export * from './CheckedCalendarOutline';
export * from './CheckedCircleOutline';
export * from './chevron-down';
export * from './chevron-left';
export * from './chevron-left-square';
export * from './chevron-right';
export * from './chevron-right-square';
export * from './chevron-up';
export * from './circle';
export * from './circle-close';
export * from './CircleQuestionMark';
export * from './client';
export * from './close-regular';
export * from './close-small';
export * from './collapse';
export * from './computer';
export * from './connected';
export * from './contract';
export * from './ContractOverdue';
export * from './ContractSigned';
export * from './Copy';
export * from './credit-card';
export * from './Cross';
export * from './Decline';
export * from './disable-autopay';
export * from './Dollar';
export * from './DollarSignCircleOutline';
export * from './download';
export * from './draft';
export * from './drag';
export * from './Due';
export * from './edit';
export * from './editDetails';
export * from './EditPen';
export * from './email';
export * from './existing-user';
export * from './expand';
export * from './Export';
export * from './facebook';
export * from './faq';
export * from './file-audio';
export * from './file-folder';
export * from './file-image';
export * from './file-pdf';
export * from './file-presentation';
export * from './file-table';
export * from './file-text';
export * from './file-video';
export * from './folder';
export * from './GoogleDrive';
export * from './Hide';
export * from './home';
export * from './Hourglass';
export * from './image';
export * from './increase';
export * from './instagram';
export * from './invoice';
export * from './invoice-received';
export * from './InvoiceDue';
export * from './Italic';
export * from './label-new';
export * from './landmark';
export * from './Lead';
export * from './learn-more';
export * from './lightning-bolt';
export * from './Link';
export * from './lock';
export * from './mail';
export * from './menu';
export * from './micro-transaction';
export * from './Minus';
export * from './money-bank';
export * from './more-vertical';
export * from './More';
export * from './move-folder';
export * from './mp3';
export * from './new-invoice';
export * from './new-proposal';
export * from './new-user';
export * from './NewContract';
export * from './OrderedList';
export * from './organization';
export * from './paperclip';
export * from './pay';
export * from './pdf';
export * from './pencil';
export * from './percentage';
export * from './phone';
export * from './picture';
export * from './pin';
export * from './pinterest';
export * from './plus';
export * from './profilePlaceHolder';
export * from './proposal';
export * from './question-mark';
export * from './QuickPayment';
export * from './RightArrowCircleOutline';
export * from './RightArrowPartialCircleOutline';
export * from './save';
export * from './search';
export * from './send';
export * from './settings';
export * from './sheet';
export * from './signature';
export * from './SignCheck';
export * from './slide';
export * from './small-arrow';
export * from './star';
export * from './star-outline';
export * from './template-contract';
export * from './TemplateInvoice';
export * from './text';
export * from './ticket';
export * from './trash';
export * from './trending';
export * from './twitter';
export * from './Underline';
export * from './unchecked';
export * from './UnorderedList';
export * from './Update';
export * from './upload';
export * from './UploadFile';
export * from './vendor';
export * from './video';
export * from './View';
export * from './Visible';
export * from './VisibleOff';
export * from './void';
export * from './warning';
export * from './warning-2';
export * from './website';

// Import for dynamic icon component
import { AcceptConnection } from './accept-connection';
import { AddEvent } from './AddEvent';
import { ArrowDownTray } from './arrow-down-tray';
import { ArrowRight } from './ArrowRight';
import { BellOff } from './BellOff';
import { BellOn } from './bell-on';
import { Bold } from './Bold';
import { BubbleWarning } from './BubbleWarning';
import { CanvaDoc } from './CanvaDoc';
import { CanvaPresentation } from './CanvaPresentation';
import { CanvaWhiteboard } from './CanvaWhiteboard';
import { Calendar } from './calendar';
import { Camera } from './camera';
import { Cash } from './cash';
import { Check } from './check';
import { CheckCircle } from './check-circle';
import { CheckCircleFilled } from './CheckCircleFilled';
import { CheckCircleIndeterminate } from './CheckCircleIndeterminate';
import { CheckCircleOutline } from './CheckCircleOutline';
import { CheckedCalendarOutline } from './CheckedCalendarOutline';
import { CheckedCircleOutline } from './CheckedCircleOutline';
import { CheckFill } from './check-fill';
import { Checked } from './checked';
import { ChevronDown } from './chevron-down';
import { Clock } from './clock';
import { ChevronLeft } from './chevron-left';
import { ChevronLeftSquare } from './chevron-left-square';
import { ChevronRight } from './chevron-right';
import { ChevronRightSquare } from './chevron-right-square';
import { ChevronUp } from './chevron-up';
import { Circle } from './circle';
import { CircleClose } from './circle-close';
import { CircleQuestionmark } from './CircleQuestionMark';
import { Client } from './client';
import { CloseRegular } from './close-regular';
import { CloseSmall } from './close-small';
import { Collapse } from './collapse';
import { Computer } from './computer';
import { Connected } from './connected';
import { Contract } from './contract';
import { ContractOverdue } from './ContractOverdue';
import { ContractSigned } from './ContractSigned';
import { ContractTemplate } from './template-contract';
import { Copy } from './Copy';
import { CreditCard } from './credit-card';
import { Cross } from './Cross';
import { Decline } from './Decline';
import { DisableAutopay } from './disable-autopay';
import { Dollar } from './Dollar';
import { DollarSignCircleOutline } from './DollarSignCircleOutline';
import { Download } from './download';
import { Draft } from './draft';
import { Drag } from './drag';
import { Due } from './Due';
import { Edit } from './edit';
import { EditDetails } from './editDetails';
import { EditPen } from './EditPen';
import { Email } from './email';
import { ExistingUser } from './existing-user';
import { Expand } from './expand';
import { Export } from './Export';
import { Facebook } from './facebook';
import { Faq } from './faq';
import { FileAudio } from './file-audio';
import { FileFolder } from './file-folder';
import { FileImage } from './file-image';
import { FilePDF } from './file-pdf';
import { FilePresentation } from './file-presentation';
import { FileTable } from './file-table';
import { FileText } from './file-text';
import { FileVideo } from './file-video';
import { Folder } from './folder';
import { GoogleDrive } from './GoogleDrive';
import { Hide } from './Hide';
import { Home } from './home';
import { Hourglass } from './Hourglass';
import { Image } from './image';
import { Info } from './Info';
import { Increase } from './increase';
import { Instagram } from './instagram';
import { Invoice } from './invoice';
import { InvoiceDue } from './InvoiceDue';
import { InvoiceReceived } from './invoice-received';
import { InvoiceTemplate } from './TemplateInvoice';
import { Italic } from './Italic';
import { Landmark } from './landmark';
import { Lead } from './Lead';
import { LearnMore } from './learn-more';
import { LightningBolt } from './lightning-bolt';
import { Link } from './Link';
import { Lock } from './lock';
import { Mail } from './mail';
import { Menu } from './menu';
import { MicroTransaction } from './micro-transaction';
import { Minus } from './Minus';
import { MoneyBank } from './money-bank';
import { More } from './More';
import { MoreVertical } from './more-vertical';
import { MoveFolder } from './move-folder';
import { MP3 } from './mp3';
import { NewContract } from './NewContract';
import { NewInvoice } from './new-invoice';
import { NewProposal } from './new-proposal';
import { NewUser } from './new-user';
import { NewLabel } from './label-new';
import { OrderedList } from './OrderedList';
import { Organization } from './organization';
import { PaperClip } from './paperclip';
import { Pay } from './pay';
import { PDF } from './pdf';
import { Pencil } from './pencil';
import { Percentage } from './percentage';
import { Phone } from './phone';
import { Picture } from './picture';
import { Pin } from './pin';
import { Pinterest } from './pinterest';
import { Plus } from './plus';
import { ProfilePlaceHolder } from './profilePlaceHolder';
import { Proposal } from './proposal';
import { QuestionMark } from './question-mark';
import { QuickPayment } from './QuickPayment';
import { RightArrowCircleOutline } from './RightArrowCircleOutline';
import { RightArrowPartialCircleOutline } from './RightArrowPartialCircleOutline';
import { Save } from './save';
import { Search } from './search';
import { Send } from './send';
import { Settings } from './settings';
import { Sheet } from './sheet';
import { SignCheck } from './SignCheck';
import { Signature } from './signature';
import { Slide } from './slide';
import { SmallArrow } from './small-arrow';
import { Star } from './star';
import { StarOutline } from './star-outline';
import { Text } from './text';
import { Ticket } from './ticket';
import { Trash } from './trash';
import { Trending } from './trending';
import { Twitter } from './twitter';
import { Underline } from './Underline';
import { Unchecked } from './unchecked';
import { UnorderedList } from './UnorderedList';
import { Update } from './Update';
import { Upload } from './upload';
import { UploadFile } from './UploadFile';
import { Vendor } from './vendor';
import { Video } from './video';
import { View } from './View';
import { Visible } from './Visible';
import { VisibleOff } from './VisibleOff';
import { Void } from './void';
import { Warning } from './warning';
import { Warning2 } from './warning-2';
import { Website } from './website';

export const Components = {
	'accept-connection': AcceptConnection,
	'add-event': AddEvent,
	'arrow-down-tray': ArrowDownTray,
	'arrow-right': ArrowRight,
	'bell-off': BellOff,
	'bell-on': BellOn,
	bold: Bold,
	'bubble-warning': BubbleWarning,
	'canva-doc': CanvaDoc,
	'canva-presentation': CanvaPresentation,
	'canva-whiteboard': CanvaWhiteboard,
	calendar: Calendar,
	camera: Camera,
	cash: Cash,
	check: Check,
	'check-circle': CheckCircle,
	'check-circle-filled': CheckCircleFilled,
	'check-circle-indeterminate': CheckCircleIndeterminate,
	'check-circle-outline': CheckCircleOutline,
	'check-fill': CheckFill,
	checked: Checked,
	'checked-calendar-outline': CheckedCalendarOutline,
	'checked-circle-outline': CheckedCircleOutline,
	'chevron-down': ChevronDown,
	'chevron-left': ChevronLeft,
	'chevron-left-square': ChevronLeftSquare,
	'chevron-right': ChevronRight,
	'chevron-right-square': ChevronRightSquare,
	'chevron-up': ChevronUp,
	circle: Circle,
	'circle-close': CircleClose,
	clock: Clock,
	'circle-questionmark': CircleQuestionmark,
	client: Client,
	'close-regular': CloseRegular,
	'close-small': CloseSmall,
	collapse: Collapse,
	computer: Computer,
	connected: Connected,
	contract: Contract,
	'contract-overdue': ContractOverdue,
	'contract-signed': ContractSigned,
	copy: Copy,
	'credit-card': CreditCard,
	cross: Cross,
	decline: Decline,
	'disable-autopay': DisableAutopay,
	dollar: Dollar,
	'dollar-sign-circle-outline': DollarSignCircleOutline,
	download: Download,
	draft: Draft,
	drag: Drag,
	due: Due,
	edit: Edit,
	editDetails: EditDetails,
	editPen: EditPen,
	email: Email,
	'existing-user': ExistingUser,
	expand: Expand,
	export: Export,
	facebook: Facebook,
	faq: Faq,
	'file-audio': FileAudio,
	'file-folder': FileFolder,
	'file-image': FileImage,
	'file-pdf': FilePDF,
	'file-presentation': FilePresentation,
	'file-table': FileTable,
	'file-text': FileText,
	'file-video': FileVideo,
	folder: Folder,
	googleDrive: GoogleDrive,
	hide: Hide,
	home: Home,
	hourglass: Hourglass,
	image: Image,
	increase: Increase,
	info: Info,
	instagram: Instagram,
	invoice: Invoice,
	'invoice-due': InvoiceDue,
	'invoice-received': InvoiceReceived,
	italic: Italic,
	'label-new': NewLabel,
	landmark: Landmark,
	lead: Lead,
	'learn-more': LearnMore,
	'lightning-bolt': LightningBolt,
	link: Link,
	lock: Lock,
	mail: Mail,
	menu: Menu,
	'micro-transaction': MicroTransaction,
	minus: Minus,
	'money-bank': MoneyBank,
	more: More,
	'more-vertical': MoreVertical,
	'move-folder': MoveFolder,
	mp3: MP3,
	'new-contract': NewContract,
	'new-invoice': NewInvoice,
	'new-proposal': NewProposal,
	'new-user': NewUser,
	'ordered-list': OrderedList,
	organization: Organization,
	paperclip: PaperClip,
	pay: Pay,
	pdf: PDF,
	pencil: Pencil,
	percentage: Percentage,
	phone: Phone,
	picture: Picture,
	pin: Pin,
	pinterest: Pinterest,
	plus: Plus,
	'profile-placeholder': ProfilePlaceHolder,
	proposal: Proposal,
	'question-mark': QuestionMark,
	quickPayment: QuickPayment,
	'right-arrow-circle-outline': RightArrowCircleOutline,
	'right-arrow-partial-circle-outline': RightArrowPartialCircleOutline,
	save: Save,
	search: Search,
	send: Send,
	settings: Settings,
	sheet: Sheet,
	signature: Signature,
	'sign-check': SignCheck,
	slide: Slide,
	'small-arrow': SmallArrow,
	star: Star,
	'star-outline': StarOutline,
	'template-contract': ContractTemplate,
	'template-invoice': InvoiceTemplate,
	text: Text,
	ticket: Ticket,
	trash: Trash,
	trending: Trending,
	twitter: Twitter,
	underline: Underline,
	unchecked: Unchecked,
	'unordered-list': UnorderedList,
	update: Update,
	upload: Upload,
	'upload-file': UploadFile,
	vendor: Vendor,
	video: Video,
	view: View,
	visible: Visible,
	visibleOff: VisibleOff,
	void: Void,
	warning: Warning,
	'warning-2': Warning2,
	website: Website,
};

const isValidIconType = ( type: string ): type is keyof typeof Components => {
	return type in Components;
};

const Icon = ( props: SVGProps<SVGSVGElement> ) => {
	const { type, ...restProps } = props;

	if ( !type || !isValidIconType( type ) ) {
		return <div className='icon-not-found' />;
	}

	const Component = Components[ type ];

	return <Component { ...restProps } />;
};

export { Icon };
